import React, { useState } from "react";
import styles from "./nav.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { IoChevronDown } from "react-icons/io5";
import { MdArrowOutward } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";

const Navbar = () => {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [submenu, setSubmenu] = useState(false);

  const handleClick = () => {
    setOpenMenu(!openMenu);
  };

  const openSubMenu = () => {
    setSubmenu(!submenu);
    console.log("clicked");
  };

  // const closeSubMenu = () => {
  //   setSubmenu(false);
  // };

  const contactClick = () => {
    navigate(`/contact`);
  };

  return (
    <React.Fragment>
      <Row className={styles.nav_section}>
        <Col className="p-0" md={2}>
          <div className={styles.logo}>
            <NavLink to={"/"}>
              <img src="/images/logo.png" alt="logo" />
            </NavLink>
          </div>
        </Col>

        {/* <Col md={4}>
          <div className={`ps-5 pt-2 ${styles.link_section}`}>
            <NavLink to="#" onMouseEnter={() => setSubmenu((prev) => !prev)}>
              About us <IoChevronDown />
            </NavLink>
            {submenu && (
              <div className={styles.submenu}>
                <div className="d-flex flex-column">
                  <h6>About Us</h6>
                  <NavLink to="/about">Our History</NavLink>
                  <NavLink to="/our-core-team">Our Core Team</NavLink>
                  <NavLink to="/our-impact">Our Impact</NavLink>
                  <NavLink to="/innovations">Innovations</NavLink>
                  <NavLink to="/clients">Clients</NavLink>
                </div>

                <div className="d-flex flex-column">
                  <h6> Products & Services</h6>
                  <NavLink to="/products-services">Products & Services</NavLink>
                  <NavLink to="/products-services">Innovations</NavLink>
                  <NavLink to="/products-services">Our Impact</NavLink>
                </div>
              </div>
            )}
            <NavLink onMouseLeave={closeSubMenu} to={"/verticals"}>
              Verticals <IoChevronDown />
            </NavLink>

            <NavLink onMouseLeave={closeSubMenu} to={"/product"}>
              {" "}
              Businesses <IoChevronDown />
            </NavLink>
          </div>
        </Col> */}

        <Col md={4}>
          <div className={`ps-5 pt-2 ${styles.link_section}`}>
            <div className={`${styles.nav_item}`}>
              <NavLink to="/about">About us </NavLink>
            </div>

            <div className={`${styles.nav_item}`}>
              <NavLink to={"/project"}>
                Project <IoChevronDown />
              </NavLink>
              <div className={styles.submenu}>
                <div className={styles.sec}>
                  <div className={styles.submenuChild}>
                    <h6>About Us</h6>
                    <NavLink to="/about">
                      Our History <MdArrowOutward />
                    </NavLink>
                    <NavLink to="#">
                      Our Core Team <MdArrowOutward />
                    </NavLink>
                    <NavLink to="#">
                      Our Impact <MdArrowOutward />
                    </NavLink>
                    <NavLink to="#">
                      Innovations <MdArrowOutward />
                    </NavLink>
                    <NavLink to="#">
                      Clients <MdArrowOutward />
                    </NavLink>
                    <NavLink to="/product">
                      Product & Service <MdArrowOutward />
                    </NavLink>
                  </div>

                  <div className={styles.another_child}>
                    <h6>Products & Services</h6>
                    <h6>Innovations</h6>
                    <h6>Our Impact</h6>
                  </div>
                </div>
              </div>
            </div>

            <div className={`${styles.nav_item}`}>
              <NavLink to={"/product"}>Businesses </NavLink>
            </div>
          </div>
        </Col>

        <Col md={4}>
          <div
            className={`ps-5 pt-2 ${styles.link_section}  ${styles.link_section2}`}
          >
            <NavLink to={"/career"}>Careers</NavLink>
            <NavLink to={"/news"}> News</NavLink>
            <NavLink to={"/project"}> vestors</NavLink>
          </div>
        </Col>

        <Col md={2} className="d-flex justify-content-end">
          <div className={styles.btn}>
            <button onClick={contactClick}>Contact Us</button>
          </div>
        </Col>
      </Row>

      {/* -----------mobile-responsive-here */}
      <div className={styles.mobile_responsive}>
        <div className={styles.logo}>
          <NavLink to={"/"}>
            <img src="/images/logo.png" alt="logo" />
          </NavLink>
        </div>
        <GiHamburgerMenu
          onClick={handleClick}
          size={34}
          className="text-white"
        />
      </div>

      <>
        {openMenu && (
          <div className={styles.responsive_menu}>
            <NavLink to="/#" onClick={openSubMenu}>
              About us <IoChevronDown />
            </NavLink>

            {submenu && (
              <div className={styles.submenu}>
                <NavLink to="/about">Our History</NavLink>
                <NavLink to="/our-core-team">Our Core Team</NavLink>
                <NavLink to="/our-impact">Our Impact</NavLink>
                <NavLink to="/innovations">Innovations</NavLink>
                <NavLink to="/clients">Clients</NavLink>
                <NavLink to="/products">Products & Services</NavLink>
                <NavLink to="/products-services">Innovations</NavLink>
              </div>
            )}
            <NavLink to="/Project" onClick={() => setOpenMenu(false)}>
              Project <IoChevronDown />
            </NavLink>
            <NavLink to="/product" onClick={() => setOpenMenu(false)}>
              Businesses <IoChevronDown />
            </NavLink>
            <NavLink to="/career">
              Careers <IoChevronDown />
            </NavLink>
            <NavLink to="/news">
              News <IoChevronDown />
            </NavLink>
            <NavLink to="/investor">Investors</NavLink>
            <div className={styles.responsive_btn}>
              <button onClick={() => navigate(`/contact`)}>Contact Us</button>
            </div>
          </div>
        )}
      </>
    </React.Fragment>
  );
};

export default Navbar;
